module.exports = __webpack_public_path__ + "img/playlist_add.ebe86068.svg";